import { guardString } from "../strings";
import type { Nullable } from "../types";

/**
 * This function is used to get the full name of a user.
 * @param firstName
 * @param lastName
 * @returns
 */
export function getFullName<
	T extends
		| {
				firstName?: Nullable<string>;
				lastName?: Nullable<string>;
		  }
		| {
				first_name?: Nullable<string>;
				last_name?: Nullable<string>;
		  },
>(item: Nullable<T>) {
	if (!item) return "N/A";
	const firstName = guardString(
		"firstName" in item ? item?.firstName : "first_name" in item ? item?.first_name : "",
		"",
	);
	const lastName = guardString(
		"lastName" in item ? item?.lastName : "last_name" in item ? item?.last_name : "",
		"",
	);
	const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
	if (!fullName) return "N/A";
	return fullName;
}
